function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling?.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })
    this.addEventListener('change', this.onVariantChange);

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );  
  }
  
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;  
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');  
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.updateOptions();
    this.updateMasterId();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// custom .js //

document.addEventListener("DOMContentLoaded", () => {
  // mobile menu //

   document.querySelector('.mobile_toggle').addEventListener('click', event => {
     document.querySelector('.mobile_toggle').classList.toggle('activate');
     document.querySelector('body').classList.toggle('overflow-hidden-tablet'); 
     document.querySelector('.mobile_outer').classList.toggle("menu_open"); 
     document.querySelector('.header-wrapper').classList.remove("remove_position");
     document.querySelector('.mobile_outer').classList.remove("remove_top");
     document.querySelectorAll('.sub-menu').forEach(Menuitem => {
       if(Menuitem.classList.contains('sub_open')){
         Menuitem.classList.remove('sub_open')
       }
     });
   });

 
  const navbarMenu = document.getElementById("navbar");
  const burgerMenu = document.getElementById("burger");

  
  // Show and Hide Navbar Function
  const toggleMenu = () => {
     navbarMenu.classList.toggle("active");
 
  };
  
  // Collapsible Mobile Submenu Function
  const collapseSubMenu = () => {
     navbarMenu.querySelector(".menu_span-main.active .sub-menu").classList.remove("sub_open");
     navbarMenu.querySelector(".menu_span-main.active").classList.remove("active");
  };
  
  // Toggle Mobile Submenu Function
  const toggleSubMenu = (e) => {
     if (e.target.hasAttribute("data-toggle") && window.innerWidth <= 992) {
        e.preventDefault();
        const menuDropdown = e.target.parentElement;
  
        // If Dropdown is Expanded, then Collapse It
        if (menuDropdown.classList.contains("active")) {
           collapseSubMenu();
        } else {
           // Collapse Existing Expanded Dropdown
           if (navbarMenu.querySelector(".menu_span-main.active")) {
              collapseSubMenu();
           }

          // setTimeout(function() {
           // Expanded the New Dropdown
           menuDropdown.classList.add("active");
         
           const subMenu = menuDropdown.querySelector(".sub-menu");
           subMenu.classList.add("sub_open");
             // }, 1000);
            
           
        }
     }
  };
  
  // Fixed Resize Window Function
  const resizeWindow = () => {
     if (window.innerWidth > 992) {
        if (navbarMenu.classList.contains("active")) {
           toggleMenu();
        }
        if (navbarMenu.querySelector(".menu_span-main.active")) {
           collapseSubMenu();
        }
     }
  };
  
  // Initialize Event Listeners
  burgerMenu.addEventListener("click", toggleMenu);
  navbarMenu.addEventListener("click", toggleSubMenu);
  window.addEventListener("resize", resizeWindow);

  
  document.querySelectorAll('.toggle_btn').forEach(item => {
    item.addEventListener('click', event => {
      event.preventDefault();
       document.querySelector('.toggle_btn').classList.toggle("menu_open");
       document.querySelector('.menu').classList.toggle("menu_active");  
       // document.querySelector('body').classList.toggle('overflow-hidden');  
    })
  });

// mobile menu end
  document.querySelector('.header__icon--account').addEventListener('click', event => {
    document.querySelector('body').classList.add('overflow-hidden');  
    var headerWidth =  document.querySelector('.header_right').getBoundingClientRect();
     var RealWidth = headerWidth.width
     document.querySelector('.login-drawer').style.width = RealWidth + "px";
  });
  
   document.querySelector('.header__icon--search').addEventListener('click', event => {
     var headerWidth =  document.querySelector('.header_right').getBoundingClientRect();
     var MainWidth = headerWidth.width
     document.querySelector('.header_search .modal__content').style.width = MainWidth + "px";
     var searchWidth = document.querySelector('.main_search__input').offsetWidth; 

       setTimeout(function() {
        document.querySelector('.header__search details').setAttribute('open', 'true');
            
        }, 100);
     
     });

  
 
// blog lode more with ajax
  
  document.querySelectorAll('.load_more').forEach(element => {
    element.addEventListener('click', function(value) {
    var $this = element,   
        totalPages = document.querySelector('#data-total').getAttribute('value'),
        currentPage = document.querySelector('#data-current').getAttribute('value');
     
     
      $this.setAttribute("disabled", "");
      currentPage =  parseInt(currentPage)+1;
      var tempUrl = document.querySelector('#data-next').getAttribute('value');
      var newUrl = tempUrl.replace(/page=[0-9]+/,'page='+currentPage)
     
      // var nextUrl = document.querySelector('#data-next').value = '/blogs/earlybird-blog?page='+currentPage;
      // console.log(nextUrl); 
      document.querySelector('#data-current').value = currentPage;
      

    var request = new XMLHttpRequest();
    request.open("GET", newUrl, true);
    request.responseType = "document";
    request.send();
    request.onreadystatechange = function() {
      if (request.readyState == 4) {
        var doc = request.response;
       
        var elem = doc.querySelector(".ajax-blog").innerHTML;
  
        document.querySelector('.ajax-blog').innerHTML += elem;
          if(currentPage >= totalPages) {
        
            $this.style.display = 'none';
          }
          if(currentPage <= totalPages) {
            $this.removeAttribute("disabled", "");
        } else{
      
          $this.hide();
        }  
      }
    }
  })
  })

if (document.querySelector(".article_right")) {
// Get the sidebar element
var sidebar = document.querySelector(".article_right");
var header = document.getElementById("shopify-section-custom_header");
var footer = document.getElementById("shopify-section-footer");

// Get the offset position of the sidebar
var sticky = sidebar.offsetTop;

// Add the sticky class to the sidebar when you reach its scroll position. Remove "sticky" when you leave the scroll position
function scrollFunction() {
    var headerTop = header.getBoundingClientRect().top;
    var footerTop = footer.getBoundingClientRect().top;
    var headerRect = header.getBoundingClientRect().height;
    
    if (window.pageYOffset >= sticky) {
        if (headerTop <= 0 && footerTop >=  700) {
            sidebar.classList.add("sticky");
            sidebar.style.top = headerRect + "px";
        } else {
            sidebar.classList.remove("sticky");
            sidebar.style.top = "0px";
        }
    } else {
    sidebar.classList.remove("sticky");
    sidebar.style.top = "0px";
  }
}
}
// Add event listener for when the user scrolls
window.addEventListener("scroll", scrollFunction);

if(window.innerWidth < 767){
 
  document.querySelector('.header__icon--search').addEventListener('click', event => {
    var ParentEl =  document.querySelector('.header__search details');
 
    if(ParentEl.hasAttribute("open") ){
     document.querySelector('.header-wrapper').classList.add("remove_position");
     document.querySelector('.mobile_outer').classList.add("remove_top");
    } else {
      document.querySelector('.header-wrapper').classList.remove("remove_position");
      document.querySelector('.mobile_outer').classList.remove("remove_top");
    }
  });
  document.querySelector('.header__icon--account').addEventListener('click', event => {
    var newParentEl =  document.querySelector('.login-drawer');

    if(newParentEl.classList.contains("drawer_open")){
     document.querySelector('.header-wrapper').classList.add("remove_position");
     document.querySelector('.mobile_outer').classList.add("remove_top");
    } else {
      document.querySelector('.header-wrapper').classList.remove("remove_position");
      document.querySelector('.mobile_outer').classList.remove("remove_top");
    }
  });
  document.querySelector('.login-drawer .icon-close').addEventListener('click', event => {

      document.querySelector('.header-wrapper').classList.remove("remove_position");
      document.querySelector('.mobile_outer').classList.remove("remove_top");
  });
  document.querySelector('.header_search .modal__content .modal__close-button').addEventListener('click', event => {
    var ParentEl =  document.querySelector('.header__search details');
 
    if(ParentEl.hasAttribute("open") ){
     document.querySelector('.header-wrapper').classList.add("remove_position");
     document.querySelector('.mobile_outer').classList.add("remove_top");
    } else {
      document.querySelector('.header-wrapper').classList.remove("remove_position");
      document.querySelector('.mobile_outer').classList.remove("remove_top");
    }
  });
}
  // header setAttribute 
document.querySelectorAll('.header-menu .menu>ul>li').forEach(AllMenu => { 
var FindA = AllMenu.querySelectorAll("a");
for (let i = 0; i < FindA.length; i++) {
  var FindAttr = FindA[i].getAttribute("href");
  if (FindAttr.includes('pdf')) {
    FindA[i].setAttribute('target', '_blank');
  } 
}
});

document.querySelectorAll('#navbar>ul>li').forEach(AllMenu => { 
  var FindA = AllMenu.querySelectorAll("a");
  for (let i = 0; i < FindA.length; i++) {
    var FindAttr = FindA[i].getAttribute("href");
    if (FindAttr.includes('pdf')) {
      FindA[i].setAttribute('target', '_blank');
    } 
  }
  });

  // footer setAttribute 
  document.querySelectorAll('.footer__blocks-wrapper .block-menu> ul > li').forEach(AllMenu => { 
    var FooterA = AllMenu.querySelectorAll("a");
    for (let i = 0; i < FooterA.length; i++) {
      var footerAttr = FooterA[i].getAttribute("href");
      if (footerAttr.includes('pdf')) {
        FooterA[i].setAttribute('target', '_blank');
      } 
    }
    });

});

document.addEventListener('DOMContentLoaded', function() {
  const checkoutButton = document.getElementById("checkout");

  if (checkoutButton) {
    checkoutButton.disabled = true;

    // Initialize the MutationObserver
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // Temporarily disconnect to avoid infinite loop
        observer.disconnect();
        if (!checkoutButton.disabled) {
          checkoutButton.disabled = true;
        }
        // Reconnect the observer
        observer.observe(checkoutButton, { attributes: true, attributeFilter: ['disabled'] });
      });
    });

    // Start observing the checkout button
    observer.observe(checkoutButton, { attributes: true, attributeFilter: ['disabled'] });

     // Function to enable the checkout button
      function enableCheckoutButton() {
        observer.disconnect();
        checkoutButton.disabled = false;
        console.log("Checkout button enabled");
      }

    const pin_code_btn = document.querySelector('.pin-code-check-main .pin-code-btn');
    
    if(pin_code_btn){
    pin_code_btn.addEventListener('click', function() {
      var zip_list = this.getAttribute('list');
      var list_of_zip = zip_list.split(',');
      var input_val = document.querySelector('.pin-code-check-main input.pin-code').value;
      var isInputValPresent = false; // Initialize a flag to false
    
      // Loop through each value in list_of_zip
      list_of_zip.forEach(function(value, index) {
        if (value.trim() === input_val.trim()) { // Use trim() to remove leading/trailing spaces for comparison
          isInputValPresent = true; // Set flag to true if input_val is found
        }
      });
    
      // Check if input_val is present in list_of_zip
      if (isInputValPresent) {
        document.getElementById("checkout").disabled = false;
        document.querySelector('.pin-code-check-content .pin-code').classList.remove("not_found");
        document.querySelector('.pin-code-check-content .pin-code').classList.add('hide');
       
        var valid_text = document.querySelector('.pin-code-check-content .label');
        valid_text.innerHTML = '';
        valid_text.innerHTML = 'Super, du bist in unserem Liefergebiet';
        
    
        // Add your desired code here for when input_val is present in list_of_zip
        // Check if the subtotal is greater than $30 and enable/disable the checkout button accordingly
          const subtotalValue = parseFloat(document.querySelector('.totals__subtotal-value').textContent.replace(/[^\d.]/g, ''));
        
          const limittotalValue = parseFloat(document.querySelector('.cart_price_limit').getAttribute("price-limit").replace(/[^\d.]/g, ''));
       
          const checkoutButton = document.getElementById("checkout");
       
          if (subtotalValue > limittotalValue) {
            enableCheckoutButton();
            checkoutButton.disabled = false;
            document.querySelector('.totals_error').style.display = 'none';
          } else {
            checkoutButton.disabled = true;
            document.querySelector('.totals_error').style.display = 'block'
          }
      } else {
        document.getElementById("checkout").disabled = true;
        document.querySelector('.pin-code-check-content .pin-code').classList.add('not_found');
        var not_valid_text = document.querySelector('.pin-code-check-content .label');
        not_valid_text.innerHTML = '';
        not_valid_text.innerHTML = 'Sorry, dahin liefern wir aktuell leider nicht. <br>Liefergebiet ansehen';
    
        // Add your desired code here for when input_val is not present in list_of_zip
      }
    
    });
    }
  }
});


const checkout_btn = document.querySelector('#checkout[name="checkout"]');
if(checkout_btn){
checkout_btn.addEventListener('click', event => {	
const local_delivery_value = document.querySelector('#local_delivery').value;	
const terms_checkbox = document.querySelector('#agree.custom-terms').checked;	
  if(local_delivery_value == ''){	
    event.preventDefault();	
    alert('Bitte wähle Lieferdatum und Uhrzeit.');	
  }else if(terms_checkbox == false){	
    alert("Bitte AGB's akzeptieren.");	
    event.preventDefault();	
  }	
  	
});
}




var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

if (screenWidth <= 425) { 
// document.querySelector('.header .mobile_outer .mobile_menu>ul>li:last-child').addEventListener('click', function() {
//   var parentDiv = document.querySelector('.header .mobile_outer');
//   setTimeout(function() {
//   parentDiv.scrollTop = parentDiv.scrollHeight - parentDiv.clientHeight;
//   },200);
// });
}

document.querySelector('.custum_header .header_right .header_search .modal__content .modal__close-button').addEventListener('click', function() {
  document.querySelector('.header__search details').removeAttribute('open');
});

if (screenWidth <= 425) { 
  const li_menu = document.querySelectorAll('.menu_span-main');
  for (var i = 0; i < li_menu.length; i++) {
    li_menu[i].style.height = `126.5px`;
  }
document.querySelector('.header .header_left #burger').addEventListener('click', function() {
  setTimeout(function() {
    const headerRightElement = document.querySelector('.header .mobile_outer.menu_open .header_right');

    // Check if the element exists before accessing its properties
    if (headerRightElement !== null) {
      const menu_height = headerRightElement.offsetHeight;
      const full_menu_height = window.innerHeight;
      const header_height = document.querySelector('.header_main').offsetHeight;

      const _height = "calc((" + full_menu_height + "px - (" + menu_height + "px + "+header_height+"px )) / 4 )";
      document.querySelector('.header .mobile_outer.menu_open').style.height = full_menu_height+"px";
      const li_menu = document.querySelectorAll('.menu_span-main');
      for (var i = 0; i < li_menu.length; i++) {
        li_menu[i].style.height = _height;
      }
      // if (document.querySelector('.header .header_left #burger').classList.contains('activate')) {
      //   document.body.style.overflow = 'hidden'; // prevent body from scrolling
      // } else {
      //   document.body.style.overflow = 'auto'; // allow body to scroll
      // }

      var menuItems = document.querySelectorAll('.header .mobile_outer .mobile_menu > ul > li');
      menuItems.forEach(function(item) {
        item.classList.remove('active');
      });
      
    }
  }, 50);
});





  
  
document.querySelectorAll('.header .mobile_outer .mobile_menu > ul > li span').forEach(function(element) {
    element.addEventListener('click', function() {
        var clickedSpan = this; // Store the clicked span element
        const menuHeight = document.querySelector('.header .mobile_outer.menu_open .header_right').offsetHeight;
        const fullMenuHeight = window.innerHeight;
        const headerHeight = document.querySelector('.header_main').offsetHeight;
        const menu_height = document.querySelector('.header .mobile_outer.menu_open .header_right').offsetHeight;

        setTimeout(function() {
            const liMenu = Array.from(document.querySelectorAll('.menu_span-main'));
          

            liMenu.forEach(function(menuItem) {
                if (menuItem.classList.contains('active')) {
                    menuItem.style.height = `auto`;
                    const parentElement = clickedSpan.parentElement;
                    clickedMenuHeight = parentElement.offsetHeight;
                    menuItem.style.height = `calc((${fullMenuHeight}px - (${menu_height}px + ${headerHeight}px)) / 4)`;
                  setTimeout(function() {
                    menuItem.style.height = `${clickedMenuHeight}px`;
                  },10);
                } else {
                    if (!liMenu.some(function(menuItem) {
                        return menuItem.classList.contains('active');
                    })) {
                        const calculatedHeight = `calc((${fullMenuHeight}px - (${menu_height}px + ${headerHeight}px)) / 4)`;
                        liMenu.forEach(function(menuItem) {
                            menuItem.style.height = calculatedHeight;
                        });
                    }else{
                            setTimeout(function() {
                                const parentElement = clickedSpan.parentElement;
                                if (parentElement) {
                                  // const clickedMenuHeight = parentElement.offsetHeight;
                                  const calculatedHeight = `calc(((${fullMenuHeight}px - (${menuHeight}px + ${headerHeight}px)) - ${clickedMenuHeight}px) / 3)`;
                                  menuItem.style.height = calculatedHeight;
                                }
                            }, 50);
                    }
                }
            });

        }, 150);
    });
});



``


  
//    const menuSpanMainList = document.querySelectorAll('.menu_span-main');
// const myDivList = document.querySelectorAll('.myDiv');

// const menuSpanMains = document.querySelectorAll('.menu_span-main');

// for (let i = 0; i < menuSpanMains.length; i++) {
//   menuSpanMains[i].addEventListener('click', function() {
//     console.log('testing', this.scrollTop);
//     setTimeout(() => {
//       this.scrollTop = this.scrollHeight;
//     }, 200);
//   });
// }




};

if(screenWidth > 425){
  
  document.querySelector('.custum_header .header_right .header_right_inner .toggle_btn a').addEventListener('click', function() {
    setTimeout(function() {
      var menu = document.querySelectorAll('.custum_header .header_right .header-menu .menu.menu_active ul.header-menu-lists .menu-lists');
      var menu_length = menu.length;
      if(menu_length > 4){
        document.querySelector('.custum_header .header_right .header-menu .menu.menu_active').style.overflowY = 'scroll';
        document.querySelector('.custum_header .header_right .header-menu .menu').style.paddingBottom = '98px';
      }
    }, 200);
  });

};

const links = document.links; 
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) { 
  if (links[i].hostname !== window.location.hostname) { 
    links[i].target = '_blank'; 
    links[i].rel = 'noreferrer noopener'; 
  } 
}




